import React from 'react';
import { Hero } from './Hero';
import { WhoWeAre } from './WhoWeAre';
import { ReferralDifference } from './ReferralDifference';
import { CoreValues } from './CoreValues';
import { AboutCTA } from './AboutCTA';
export function About() {
  return <div className="min-h-screen bg-background" data-id="element-147">
      <Hero data-id="element-148" />
      <WhoWeAre data-id="element-149" />
      <ReferralDifference data-id="element-150" />
      <CoreValues data-id="element-151" />
      <AboutCTA data-id="element-152" />
    </div>;
}